import Header from "../components/Header.jsx"
import "../styles/FirstFeature.css"

function FirstFeature () {
    return (
        <>
            <Header />
            <div className="first_feature">
                <h2>This is a new page describing the feature</h2>
            </div>
        </>
    );
}

export default FirstFeature;